import { IVirtualRoutesProviderTypeName } from "./virtual-routes-provider.interface";
export class VirtualRoutesProviderHolder {
    constructor(serviceCollection) {
        this.serviceCollection = serviceCollection;
    }
    getVirtualRoutes() {
        const providers = this.serviceCollection.resolveAll(IVirtualRoutesProviderTypeName);
        return providers.map(provider => {
            try {
                return provider.getVirtualRoutes();
            }
            catch (e) {
                console.error(e);
                return [];
            }
        }).flatMap(virtualRoutes => virtualRoutes);
    }
    getVirtualRouteUniqueName(virtualRoute) {
        return `routing_virtual-route_${virtualRoute.code}`;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlydHVhbC1yb3V0ZXMtcHJvdmlkZXIuaG9sZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3NoYXJlZC9taWNyby1mcm9udGVuZHMvdmlydHVhbC1yb3V0ZXMvdmlydHVhbC1yb3V0ZXMtcHJvdmlkZXIuaG9sZGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtBLE9BQU8sRUFBeUIsOEJBQThCLEVBQUMsTUFBTSxxQ0FBcUMsQ0FBQztBQUUzRyxNQUFNLE9BQWdCLDJCQUEyQjtJQUc3QyxZQUFzQixpQkFBcUM7UUFDdkQsSUFBSSxDQUFDLGlCQUFpQixHQUFHLGlCQUFpQixDQUFDO0lBQy9DLENBQUM7SUFFTSxnQkFBZ0I7UUFDbkIsTUFBTSxTQUFTLEdBQUcsSUFBSSxDQUFDLGlCQUFpQixDQUFDLFVBQVUsQ0FBeUIsOEJBQThCLENBQUMsQ0FBQztRQUM1RyxPQUFPLFNBQVMsQ0FBQyxHQUFHLENBQWlCLFFBQVEsQ0FBQyxFQUFFO1lBQzVDLElBQUk7Z0JBQ0EsT0FBTyxRQUFRLENBQUMsZ0JBQWdCLEVBQUUsQ0FBQzthQUN0QztZQUFDLE9BQU8sQ0FBQyxFQUFFO2dCQUNSLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUM7Z0JBQ2pCLE9BQU8sRUFBRSxDQUFDO2FBQ2I7UUFDTCxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsYUFBYSxDQUFDLEVBQUUsQ0FBQyxhQUFhLENBQUMsQ0FBQztJQUMvQyxDQUFDO0lBRU0seUJBQXlCLENBQUMsWUFBMEI7UUFDdkQsT0FBTyx5QkFBeUIsWUFBWSxDQUFDLElBQUksRUFBRSxDQUFDO0lBQ3hELENBQUM7Q0FDSiJ9